import React from 'react'

const EthosGuaranteePage = () => {
  return (
    <div className='min-h-screen bg-gray-50 flex items-center justify-center p-4'>
      <div className='bg-white p-8 rounded-lg shadow-md max-w-3xl w-full mt-32 md:mt-0'>
        <h1 className='text-3xl font-semibold text-center mb-6 text-brandPrimary'>
          The Ethos Guarantee
        </h1>
        <p className='text-xl text-center mb-8 text-gray-700'>
          Your Charter, Your Legacy: A Risk-Free Promise
        </p>
        <div className='space-y-6'>
          <p className='text-lg text-gray-700'>
            At Ethos Yachting, we don’t just manage yachts; we guarantee your
            success. Here’s our promise:
          </p>

          <ul className='space-y-4 list-disc pl-6 text-lg text-gray-700'>
            <li>
              <strong className='text-brandPrimary'>
                Maximum Profit Assurance:
              </strong>{' '}
              We commit to delivering at least 20% higher annual revenue than
              the average industry performance for your yacht type in the
              region, or we will refund 100% of our management fees for the
              year—no questions asked.
            </li>
            <li>
              <strong className='text-brandPrimary'>
                No Empty Weeks Guarantee:
              </strong>{' '}
              If your yacht sits idle for more than 4 weeks during peak season,
              we will personally cover the operational costs for those weeks.
            </li>
            <li>
              <strong className='text-brandPrimary'>
                The VIP Experience Standard:
              </strong>{' '}
              Every guest aboard your yacht will receive a perfect 5-star
              experience—a promise we back with $5,000 paid to you for any valid
              guest complaint unresolved within 48 hours.
            </li>
            <li>
              <strong className='text-brandPrimary'>
                Ethos Ethical Profit Model:
              </strong>{' '}
              Our management fees are tied to your yacht’s performance. If your
              yacht doesn’t turn a profit, neither do we. This keeps us aligned
              with your success at all times.
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default EthosGuaranteePage
